"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterForOption = void 0;
var Option_1 = require("./Option");
/**
 *  Returns `None` if the option is `None`,
 *  otherwise the result should be resolved by the result of _predicate_ with the wrapped value as the arguments:
 *
 *      * `Some(t)` if _predicate_ returns `true`.
 *      * `None` if _predicate_ returns `false`.
 */
function filterForOption(input, predicate) {
    if ((0, Option_1.isNone)(input)) {
        return input;
    }
    var ok = predicate(input.val);
    if (!ok) {
        return (0, Option_1.createNone)();
    }
    var result = input;
    return result;
}
exports.filterForOption = filterForOption;
